import { createSelector } from 'reselect';
import { SCOPES } from '../utils/constants';
import { selectAuthUserScopesSet } from './AuthSelectors';
export const selectHasSlowRolloutScope = createSelector([selectAuthUserScopesSet], scopeSet => scopeSet.has(SCOPES.SLOW_ROLLOUT));
export const selectHasBetaAdminAccessScope = createSelector([selectAuthUserScopesSet], scopeSet => scopeSet.has(SCOPES.BETA_ADMIN_ACCESS));